/* What a page shows while its data is on the way, and when it never came. */

import { el, fill } from "./dom";

export function showLoading(host: HTMLElement): void {
  fill(host, el("p", { class: "boot" }, "Loading the ranges…"));
}

export function showFatal(host: HTMLElement, error: unknown): void {
  const message = error instanceof Error ? error.message : String(error);
  fill(
    host,
    el(
      "div",
      { class: "boot" },
      el("p", { class: "warn" }, message),
      el("p", {}, "Nothing is cached on this device yet, so there is nothing to show offline."),
      el("button", { class: "copy", onclick: () => location.reload() }, "Try again"),
    ),
  );
}
